// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-verification-deep-link-landing-container {
  display: flex;
  flex:1 1;
  justify-content: center;
  align-items: center;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/Containers/Pages/Unauthed/EmailVerificationDeeplink/EmailVerificationDeeplinkLanding.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAM;EACN,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".email-verification-deep-link-landing-container {\n  display: flex;\n  flex:1;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
